@if (title) {
  <lg-heading [level]="2" class="heading heading__title">
    {{ title }}
  </lg-heading>
}

@if (subtitle) {
  <div
    [wysiwygContainer]="'Heading Component'"
    class="lg-font-size-3 heading heading__subtitle wysiwyg"
    dotcomFrontendWysiwyg
    [innerHTML]="subtitle"
  ></div>
}
